module.exports = __webpack_public_path__ + "static/img/3_1.2f013b37.jpg";